<script setup lang="ts">
import type { SmsChatMessagePreviewUnitProps } from '@/components/units/SmsChatMessagePreviewUnit.vue';

import { useRoute } from 'vue-router';

import TableEmptyText from '@/components/texts/TableEmptyText.vue';
import SmsChatMessagePreviewUnit from '@/components/units/SmsChatMessagePreviewUnit.vue';
import { useSmsChatViewStore } from '@/stores/useSmsChatViewStore';
import * as routeNames from '@/constants/routeNames';

const props = withDefaults(defineProps<Props>(), {
  messagePreviews: () => [],
});

const emit = defineEmits<{
  messagePreviewClick: [
    event: PointerEvent,
    messagePreview: SmsChatMessagePreviewUnitProps,
  ];
}>();

const route = useRoute();
const smsChatViewStore = useSmsChatViewStore();

export interface Props {
  messagePreviews?: SmsChatMessagePreviewUnitProps[];
}

function handleMessagePreviewClick(
  event: PointerEvent,
  messagePreview: SmsChatMessagePreviewUnitProps,
): void {
  emit('messagePreviewClick', event, messagePreview);
}
</script>

<template>
  <section
    :class="$style.smsChatRosterSection"
    data-testid="smsChatRosterSection"
  >
    <TableEmptyText v-if="!props.messagePreviews.length">
      No messages
    </TableEmptyText>
    <template v-else>
      <router-link
        v-for="(messagePreview, index) in props.messagePreviews"
        :key="messagePreview.id"
        :class="$style.link"
        :to="{
          name: routeNames.SMS_CHAT,
          query: { ...route.query, recipient: messagePreview.id },
        }"
      >
        <SmsChatMessagePreviewUnit
          :class="$style.previewUnit"
          :name="messagePreview.name"
          :datetime="messagePreview.datetime"
          :message="messagePreview.message"
          :is-active="
            messagePreview.id === smsChatViewStore.query.recipient?.toString()
          "
          :is-read="messagePreview.isRead"
          @click="handleMessagePreviewClick($event, messagePreview)"
        />
      </router-link>
    </template>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatRosterSection {
}
  .link {
    text-decoration: none;
    color: inherit;
  }
  .previewUnit {
  }
</style>
